import axiosClient from './axiosClient';

export async function trackFeatureUsage(customerId: string | number | null | undefined, featureType: string) {
  console.log('trackFeatureUsage called with:', { customerId, featureType });

  const validFeatures = [
    'Create in Seconds Button Clicked',
    'Start Hunting Button Clicked',
    'See Details',
    'Create New Listing',
    'Listing Created - Marketing',
    "Listing Created - Home",
    'Switch Listing',
    'Send Application',
    'Edit Availability',
    'Copy AI Email',
    'Listing Info',
    'Copy Title',
    'Copy Description - Marketing',
    "Copy Screening Link",
    "Tried Screening Link",
    'Copy Listing Description -App',
    'Copy Listing Screening Link -App',
    'Renter-Ad-0-Clicked'
  ]


  if (!validFeatures.includes(featureType)) {
    console.warn(`Invalid featureType passed to trackFeatureUsage: "${featureType}"`)
    return
  }

  try {
    console.log('Making API call to track feature usage...');
    const payload: { customer_id?: string | number | null; feature_type: string } = {
      feature_type: featureType,
    };
    if (customerId != null) {
      payload.customer_id = customerId;
    } else {
      payload.customer_id = null; // explicit null to signal global tracking
    }
    const response = await axiosClient.post('/api/v1/feature_usages/increment', payload);
    console.log('Feature tracking API response:', response.data);
  } catch (error) {
    console.error('Feature tracking failed:', error);
  }
}